import {
  useAppDispatch,
  useAppSelector,
} from '../../../../../../redux/store.model';
import getAddressesCoordinates from '../../../../../../redux/addressesCoordinates/actions';
import { getPolyglot } from '../../../../../../i18n';
import { useShowErrorMessage } from '../../../../../../handlingErrors';
import { MapComponent } from '../../../../../../components/DeviceManager/Group/Overview/MapDevices/Map';
import { useDevices } from '../../../../../../redux/commander/hooks/useDevices';
import { Device } from '../../../../../../redux/commander/api/device.model';
import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

const mapStyle = { height: '30vh' };
export const MapWithDevices = (props: { devicesIds: string[] }) => {
  const { devicesIds } = props;
  const { data: devices, isLoading: isLoadingDevices } = useDevices(devicesIds);
  const addressesCoordinates = useAppSelector(
    (state) => state.addressesCoordinates.addressesCoordinates
  );
  const accessToken = useAppSelector((state) => state.auth.accessToken);
  const polyglot = getPolyglot();
  const handleShowError = useShowErrorMessage();
  const dispatch = useAppDispatch();

  const getAddressesCoordinatesFn = (devices: Device[]) =>
    dispatch(getAddressesCoordinates(devices));

  if (isLoadingDevices)
    return (
      <Box display={'flex'} flexDirection={'column'}>
        <CircularProgress />
        <Typography>{polyglot.t('group.loading_data_message')}</Typography>
      </Box>
    );
  else
    return (
      <MapComponent
        mapStyle={mapStyle}
        devices={devices}
        accessToken={accessToken}
        addressesCoordinates={addressesCoordinates}
        getAddressesCoordinates={getAddressesCoordinatesFn}
        polyglot={polyglot}
        handlingErrorsApi={handleShowError}
        displayControls={true}
        {...props}
      />
    );
};
